import { memo } from 'react';

import { ValidationPanel } from '@/components/flow';

import { SlideOut } from './SlideOut.tsx';

export type ValidationPanelSlideOutProps = {
  actionId: string;
  agentId: string;
  validationId: string;
};

const IValidationPanelSlideOut = ({ agentId, actionId, validationId }: ValidationPanelSlideOutProps) => {
  return (
    <SlideOut>
      <ValidationPanel actionId={actionId} agentId={agentId} validationId={validationId} />
    </SlideOut>
  );
};

export const ValidationPanelSlideOut = memo(IValidationPanelSlideOut) as typeof IValidationPanelSlideOut;
